import dayjs, { Dayjs } from "dayjs"
import ParseError from "@/types/ParseError"
import { GetAlpsRangeQuery } from "@/api/hasura/generated/graphql"

const JAN_1_1900 = dayjs("1900-01-01")
const DEC_31_1900 = dayjs("1900-12-31")

const rebaseDate = (date: Dayjs): Dayjs => {
  const isLeapDay = date.month() === 1 && date.date() === 29
  return JAN_1_1900.set("month", date.month()).set(
    "date",
    isLeapDay ? 28 : date.date(),
  )
}

export const buildAlpsRangeVariables = (startDate: string, endDate: string) => {
  const start = rebaseDate(dayjs(startDate))
  const end = rebaseDate(dayjs(endDate))
  const wrapsYear = end.isBefore(start)

  const format = (d: Dayjs) => d.format("YYYY-MM-DD")

  return {
    from1: format(wrapsYear ? JAN_1_1900 : start),
    to1: format(end),
    from2: format(start),
    to2: format(wrapsYear ? DEC_31_1900 : end),
  }
}

export const AlpsRangeParser = {
  toDomain: (
    data: GetAlpsRangeQuery,
    startDate: string,
    endDate: string,
  ): number => {
    try {
      const start = dayjs(startDate)
      const end = dayjs(endDate)

      const yearDiff = end.year() - start.year()
      const wrapsYear = rebaseDate(end).isBefore(rebaseDate(start))

      const aggregate = data.energy_usage_load_factors_aggregate.aggregate
      const alpsSum = Number(aggregate?.sum?.electricity_r1 ?? 0)

      return alpsSum + yearDiff - (wrapsYear ? 1 : 0)
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
